import { Box, Grid } from '@mui/material';
import { Card } from '@apigrowfinance/pbolt-card';
import { useTheme } from '@apigrowfinance/pbolt-theme-provider';
import { Outlet } from 'react-router-dom';

import TabStrip from '@pages/accountDetail/components/accountDetailTabStrip/AccountDetailTabStrip';

const DetailLayout = () => {
    const { theme } = useTheme();
    return (
        <Box
            sx={{
                mt: 1.5,
                display: 'flex',
                justifyContent: 'center',
                bgcolor: theme?.palette?.background?.default,
            }}>
            <Grid container>
                <Card isBottomRadiusBorder={false}>
                    <TabStrip />
                </Card>
                <Grid container>
                    <Outlet />
                </Grid>
            </Grid>
        </Box>
    );
};

export default DetailLayout;
